import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { WebPageSchema, BreadcrumbListSchema, ArticleSchema } from '@/components/feature/SchemaOrg';
import { featuredArticles, latestArticles, categories } from '@/mocks/home';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const allArticles = [...featuredArticles, ...latestArticles];
  const article = allArticles.find((a) => a.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-16 min-h-[60vh] flex items-center justify-center">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
              <i className="ri-file-unknow-line text-2xl text-foreground-400"></i>
            </div>
            <h1 className="text-xl font-heading text-foreground-800 mb-2">文章未找到</h1>
            <Link to="/" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <WebPageSchema
        title={`${article.title} - 奶水动漫`}
        description={article.excerpt}
        url={`https://www.naishuidongman.com/article/${article.slug}`}
      />
      <BreadcrumbListSchema
        items={[
          { name: '首页', url: 'https://www.naishuidongman.com/' },
          { name: article.categoryName, url: `https://www.naishuidongman.com/category/${article.category}` },
          { name: article.title },
        ]}
      />
      <ArticleSchema
        title={article.title}
        description={article.excerpt}
        datePublished={article.date}
        author={article.author}
        imageUrl={article.coverImage}
        url={`https://www.naishuidongman.com/article/${article.slug}`}
        categoryName={article.categoryName}
      />
      <Navbar />
      <main className="pt-16">
        <article className="w-full px-4 md:px-6 py-8">
          <div className="max-w-4xl mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <span className="text-foreground-300">/</span>
              <Link to={`/category/${article.category}`} className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">{article.categoryName}</Link>
              <span className="text-foreground-300">/</span>
              <span className="text-foreground-700 whitespace-nowrap">{article.title}</span>
            </nav>

            <div className="mb-6">
              <div className="flex items-center gap-3 mb-4 flex-wrap">
                <span className="px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">
                  {article.categoryName}
                </span>
                <span className="text-sm text-foreground-400 whitespace-nowrap">{article.date}</span>
                <span className="text-sm text-foreground-400 whitespace-nowrap">{article.readTime}</span>
              </div>
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-800 mb-4 leading-tight">
                {article.title}
              </h1>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-user-line text-lg text-primary-500"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-700">{article.author}</div>
                </div>
              </div>
            </div>

            <div className="aspect-[16/9] md:aspect-[21/9] rounded-xl overflow-hidden mb-8">
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="prose prose-lg max-w-none">
              <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
                <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
                  {article.excerpt}
                </p>
                <p>
                  在这篇漫画中，我们将通过生动有趣的动漫角色和场景，带你一步步了解{article.categoryName}的相关知识。
                  无论你是准妈妈还是正在哺乳期的新手妈妈，都能从这篇内容中获得实用的哺乳育儿指导。
                </p>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-800 mt-8 mb-3">一、基础入门篇</h2>
                <p>
                  对于很多新手妈妈来说，哺乳这件事既期待又紧张。别担心！在奶水动漫的世界里，我们请来了可爱的哺乳小助手"奶宝"，
                  它会用最通俗易懂的方式，手把手教大家掌握正确的哺乳方法。
                </p>
                <p>
                  漫画中的主角小美是一位刚生完宝宝的新手妈妈，她也在哺乳路上遇到了不少困难。但通过不断学习和实践，
                  小美逐渐找到了适合自己的哺乳方式。相信你也能和小美一样，成为自信的哺乳妈妈！
                </p>

                <h2 className="text-xl md:text-2xl font-heading text-foreground-800 mt-8 mb-3">二、进阶技巧篇</h2>
                <p>
                  掌握了基础之后，我们来看看一些进阶的哺乳技巧。这些技巧可以帮助你和宝宝建立更顺畅的哺乳节奏，
                  让哺乳过程更加舒适高效。
                </p>
                <p>
                  漫画中小美的妈妈（一位经验丰富的过来人）分享了她的哺乳心得：保持良好的心态非常重要，
                  紧张和焦虑会影响奶水的分泌。所以，放松心情，享受和宝宝亲密接触的美好时光吧！
                </p>
                <p>
                  同时，科学的喂养频率也很关键。新生儿通常需要每2-3小时喂一次奶，但每个宝宝都有自己的节奏。
                  观察宝宝的饥饿信号——舔嘴唇、吸吮手指、转头寻找——比盯着时钟更重要哦。
                </p>

                <h2 className="text-xl md:text-2xl font-heading text-foreground-800 mt-8 mb-3">三、答疑解惑篇</h2>
                <p>
                  在我们收到的妈妈来信中，很多人都有相似的困惑。比如："为什么宝宝总是在傍晚哭闹，是不是我奶水不够？"
                  其实这很可能是正常的"黄昏闹"现象，和奶水是否充足没有直接关系。
                </p>
                <p>
                  还有一些妈妈担心奶水太稀、不够营养。事实上，人体非常智能，母乳会根据宝宝的需求自动调节成分。
                  前奶较稀（含更多水分和乳糖），后奶较浓（含更多脂肪），所以让宝宝充分吸吮一侧再换另一侧很重要。
                </p>

                <h2 className="text-xl md:text-2xl font-heading text-foreground-800 mt-8 mb-3">四、总结与建议</h2>
                <p>
                  哺乳是一段独特而珍贵的旅程。在这条路上，你可能会遇到各种挑战，但请记住：你并不孤单。
                  奶水动漫会一直陪伴在你身边，用温暖治愈的动漫故事，陪你度过每一个哺乳的日日夜夜。
                </p>
                <p>
                  如果你想看到更多相关主题的漫画内容，欢迎在评论区告诉我们！也别忘了订阅我们的更新通知，
                  第一时间获取最新内容推送哦。
                </p>
              </div>
            </div>

            <div className="mt-10 pt-8 border-t border-background-200/70">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-sm text-foreground-500 whitespace-nowrap">标签：</span>
                {article.tags.map((tag) => (
                  <span key={tag} className="px-3 py-1 bg-background-100 text-foreground-600 text-xs rounded-full whitespace-nowrap">
                    #{tag}
                  </span>
                ))}
              </div>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 p-6 bg-background-100 rounded-xl">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-user-line text-lg text-primary-500"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-700">{article.author}</div>
                  <div className="text-xs text-foreground-400">奶水动漫内容创作者</div>
                </div>
              </div>
              <Link
                to="/"
                className="px-5 py-2 text-sm bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                返回首页看更多
              </Link>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}